export type TokenType = 'resetPassword';
